import React, { ReactNode } from 'react';
import { makeStyles, createStyles } from '@quillbot/design-system';
import { TextField, TextFieldProps, Theme } from '@quillbot/design-system';

// custom input box component created on material textField to align with theme
interface MyProps {
  passBorderColor?: string;
  isBorder?: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: (props: MyProps) =>
        props.isBorder ? `1px solid ${props.passBorderColor || theme.palette.divider} ` : '',
      overflow: 'hidden',
      borderRadius: 4,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      backgroundColor: theme.palette.grey[50],
      '&:hover': {
        backgroundColor: theme.palette.grey[50],
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[50],
        // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        boxShadow: 'none',
        borderColor: theme.palette.primary.main,
      },
      '&$multiline': {
        paddingTop: '3px',
      },
    },
    multiline: {
      padding: 0,
    },
    error: {
      border: (props: MyProps) => `1px solid ${theme.palette.error.main}`,
    },
    textFieldLabel: {
      color: theme.palette.text.disabled,
    },

    focused: {},
    inputMarginDense: {
      padding: '21px 12px 5px',
    },
  })
);

const useStylesForMsgBox = makeStyles(() =>
  createStyles({
    onlyForMessageBox: {
      '& textarea': {
        paddingTop: '0px',
        paddingBottom: '26px',
        marginTop: '20px',
      },
    },
  })
);
// interface IProps extends  {}
function MyInputBox(
  props: TextFieldProps & { isBorder?: boolean; passBorderColor?: string; endAdornment?: ReactNode }
) {
  // const { ...childProps } = props;
  const { passBorderColor, isBorder = true } = props;
  const classes = useStyles({
    passBorderColor,
    isBorder,
  });

  const classesForMsgBox = useStylesForMsgBox();
  return (
    <TextField
      InputProps={{
        classes,
        disableUnderline: true,
        endAdornment: props.endAdornment,
      }}
      InputLabelProps={{
        className: classes.textFieldLabel,
      }}
      className={props.label === 'Message' ? classesForMsgBox.onlyForMessageBox : undefined}
      {...props}
    />
  );
}

export default MyInputBox;
